// Ads disabled — component returns null site-wide.
// To re-enable, restore the previous ad network integration.
export default function AdsDisplay() {
  return null;
}
